import { render } from "./dark.svg?vue&type=template&id=1e0036d6?inline"
const script = {}

import exportComponent from "/build/cloudstack-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__